import React, { useEffect, useState } from 'react'
import Header from '../../components/Header.jsx'
import SearchInput from '../../components/SearchInput.jsx'
import { authAxios } from '../../helpers/axios.js'
import { toast } from 'react-toastify'
import { useNavigate,useLocation, Link } from 'react-router-dom'
import { InfoToast } from '../../helpers/toasters.js'
import { LIMIT } from '../../helpers/constants.js'
import SortIcon from '../../images/sort.svg'
import RightIcon from '../../images/right.svg'
import FilterIcon from '../../images/filter.svg'
import FilterActiveIcon from '../../images/filteractive.svg'
import ManageTea from './components/ManageTea.jsx'
import FilterTea from './components/FilterTea.jsx'
import { getDateFormat, getTimeFormat } from '../../helpers/utils.js'

export default function RawTea() {

    const location = useLocation()
    const [searchText,setSearchText] = useState('')
    const [gardens,setTeaLists] = useState([])
    const [showCreate,setShowCreate] = useState({status:false,edit:null})
    const [exporting,setExporting] = useState(false)
    const navigate = useNavigate()

    const [offset,setOffset] = useState(0);
    const [count,setCount] = useState(0)

    const [filters,setFilters] = useState({gradeId:null,gardenId:null,startDate:null,endDate:null,showEmpty:0,startRate:null,endRate:null,type:null,cityId:null})
    const [showFilters,setShowFilters] = useState(false)
    const [sort,setSort] = useState('-createdAt');
    
    const onFilterSubmit = (filters)=>
    {
        try 
        {
            setFilters({...filters})
            setCount(5)
            setOffset(0)
            setShowFilters(false)
            const params = new URLSearchParams(location.search);
            if (filters.gradeId) params.set('gradeId', filters.gradeId);
            else params.delete('gradeId')
            if (filters.gardenId) params.set('gardenId', filters.gardenId);
            else params.delete('gardenId')
            if (filters.startDate) params.set('startDate', filters.startDate);
            else params.delete('startDate')
            if (filters.endDate) params.set('endDate', filters.endDate);
            else params.delete('endDate')
            if(filters.showEmpty && (filters.showEmpty === 1 || filters.showEmpty === 0)) params.set('showEmpty',1)
            else params.delete('showEmpty')
            if(filters.startRate) params.set('startRate',filters.startRate)
            else params.delete('startRate')
            if(filters.endRate) params.set('endRate',filters.endRate)
            else params.delete('endRate')
            if(filters.type) params.set('type',filters.type)
            else params.delete('type')
            if(filters.cityId) params.set('cityId',filters.cityId)
            else params.delete('cityId')
            navigate({ search: params.toString() });
        } catch (error) {
            toast('Order Filtered')
        }
    }

    const clearFilter = ()=>
    {
        try 
        {
            setFilters({gardenId:null,gradeId:null,startDate:null,endDate:null,showEmpty:0})
            setShowFilters(false)
            const params = new URLSearchParams(location.search);
            params.delete('gradeId');
            params.delete('gardenId');
            params.delete('startDate'); 
            params.delete('endDate');
            params.delete('startRate');
            params.delete('endRate');
            params.delete('type');
            params.delete('cityId');
            if(filters.showEmpty === 1 || filters.showEmpty === true) params.set('showEmpty',1)
            else params.delete('showEmpty');
            navigate({ search: params.toString() });
        } catch (error) {
            toast('Order Filtered')
        }
    }

    const onSortPress = (type)=>
    {
        const params = new URLSearchParams(location.search);
        if (sort === type) {
            if(sort === `-${type}`) setSort(type)
            else setSort(`-${type}`);
            params.set('sort', `-${type}`);
          } else {
            setSort(type);
            params.set('sort', type);
          }
          setOffset(0)
          navigate({ search: params.toString() });
    }
    
    async function getTeaLists(search,sort,offset,filters){

        try 
        {
            let query = `&limit=${LIMIT}&offset=${offset}&sort=${sort}`;
                if(search) query+= `&search=${search}`;
                if(filters.gardenId) query+=`&gardenId=${filters.gardenId}`
                if(filters.gradeId) query+=`&gradeId=${filters.gradeId}`
                if(filters.startRate) query+=`&startRate=${filters.startRate}`
                if(filters.endRate) query+=`&endRate=${filters.endRate}`
                if(filters  && (filters.showEmpty === 1 || filters.showEmpty === '1' || filters.showEmpty === 0 || filters.showEmpty === '0')) query+=`&showEmpty=${filters.showEmpty}`
                if(filters.type) query+=`&type=${filters.type}`
                if(filters.cityId) query+=`&cityId=${filters.cityId}`
                if(filters.startDate && filters.endDate) query+=`&startDate=${filters.startDate}&endDate=${filters.endDate}`
            let res = await authAxios.get(`${process.env.REACT_APP_BASE_URL}/tea?populate=true${query}`)
            if(res.data.data) 
            {
                setTeaLists(res.data.data)
                setCount(res.data.count)
            }
        } catch (error) {
            console.log(error)
            toast('Error getting tea list')
        }
    }

    useEffect(()=>
    {
        getTeaLists(searchText,sort,offset,filters)
    },[filters,searchText,offset,sort])

    const RightContent = ()=>
    {
        return <div>
          <button type='button' className='btn-md' onClick={()=>setShowCreate({status:true,edit:null})}>Create Tea Entry</button>
        </div>
    }

    const onSubmit = async(e,data)=>
    {
        try 
        {
            e.preventDefault()

            const formData = new FormData();
            
            // Add all data fields to formData
            Object.keys(data).forEach(key => {
                if (key === 'teabags') {
                    formData.append('teabags', JSON.stringify(data[key]));
                }
                else if (key !== 'invoiceDoc') {
                    formData.append(key, data[key]);
                }
            });

            // Add file if it exists
            if (data.invoiceDoc) {
                formData.append('invoiceDoc', data.invoiceDoc);
            }

            let res;
            if(showCreate.edit)
            {
                InfoToast('Tea Updated')
                res = await authAxios.put(`${process.env.REACT_APP_BASE_URL}/tea/${showCreate.edit}`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }); 
            }
            else
            {
                res = await authAxios.post(`${process.env.REACT_APP_BASE_URL}/tea`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                InfoToast('Garden Created')
            }
            if(res.data)
            {
                await getTeaLists(searchText,sort,offset,filters)
                setShowCreate({status:false,edit:null})
            }
            else toast('error updating tea')
        } catch (error) {
            console.log(error)
            toast(error?.response?.data?.error || 'Error updating tea')
        }
    }
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const search = params.get('search') || '';
        const sort = params.get('sort') || '-createdAt';
        const offset = parseInt(params.get('offset')) || 0;
        const filters = {
            gradeId: params.get('gradeId') || null,
            gardenId: params.get('gardenId') || null,
            startDate: params.get('startDate') || null,
            endDate: params.get('endDate') || null,
            showEmpty: params.get('showEmpty') || 0,
            startRate: params.get('startRate') || null,
            endRate: params.get('endRate') || null,
            type: params.get('type') || null,
            cityId: params.get('cityId') || null
        };

        setSearchText(search);
        setSort(sort);
        setOffset(offset);
        setFilters(filters);
        navigate({ search: params.toString() });
        if (search !== '' || Object.values(filters).some(value => value !== null)) {
            getTeaLists(search, sort, offset, filters);
        }
    }, [location.search]);


    const onSearchChange = (value)=>
    {
        setSearchText(value);
        setOffset(0)
        const params = new URLSearchParams(location.search);
        params.set('search', value);
        params.set('offset', 0);
        navigate({ search: params.toString() });
    }

    const onPageChange = (newOffset)=>
    {
        if(newOffset >= 0 && newOffset < count){
            setOffset(newOffset);
            const params = new URLSearchParams(location.search);
            params.set('offset', newOffset);
            navigate({ search: params.toString() });
        }
    }

  return (
    <>
        <Header title={'Raw Tea Management'} RightContent={RightContent}/>
        <div className='flex justify-between items-stretch border-b border-[#e3e3e3] bg-white'>
        <div className='flex'>
                <SearchInput value={searchText} setValue={onSearchChange} placeholder={'Search Garden'} label={'Search Garden'} />
            <div className='flex w-full border-r items-center h-full justify-center text-center'>
                    <div className='px-2 hover:bg-[#f6f6f6] h-full cursor-pointer flex items-center flex-1 justify-center' onClick={()=>onPageChange(offset - LIMIT)}>
                        <img src={RightIcon} className='w-[20px] h-[20px] rotate-180'/>
                    </div>
                    <p className='text-xs whitespace-nowrap w-[80px] justify-center'>{offset + 1}-{Math.min(offset + LIMIT, count)} of {count}</p>
                    <div className='px-2 hover:bg-[#f6f6f6] h-full cursor-pointer flex items-center flex-1 justify-center' onClick={()=>onPageChange(offset + LIMIT)}>
                        <img src={RightIcon} className='w-[20px] h-[20px]'/>
                    </div>
                </div>
                </div>
                <div className='flex justify-end h-[100%] self-stretch items-center px-4 border-l border-[#e3e3e3] hover:bg-[#f6f6f6] cursor-pointer' onClick={()=>setShowFilters(true)}>
            {(filters.cityId || filters.routeId || filters.status) ? <img src={FilterActiveIcon} className={`w-[24px] h-[24px]`} alt='Filter' /> : <img src={FilterIcon} className={`w-[24px] h-[24px]`} alt='Filter' /> }
            </div>
        </div>
        <div className='flex-1 bg-white w-full flex overflow-scroll'>
            <table className='table-auto w-full flex-1'>
                <thead className='bg-[#f9f9f9] w-full'>
                    <tr className='w-full'>
                    <td><p onClick={()=>onSortPress('gardenName')} className='cursor-pointer flex items-center hover:text-black'>Garden Name{sort === 'gardenName' || sort === '-gardenName'? sort.charAt(0)==='-' ? <img src={SortIcon} className='rotate-[180deg] h-[16px] w-[16px] ml-1'/> : <img src={SortIcon} className='h-[16px] w-[16px] ml-1'/> : null}</p></td>
                    <td><p onClick={()=>onSortPress('gradeId')} className='cursor-pointer flex items-center hover:text-black'>Grade{sort === 'gradeId' || sort === '-gradeId'? sort.charAt(0)==='-' ? <img src={SortIcon} className='rotate-[180deg] h-[16px] w-[16px] ml-1'/> : <img src={SortIcon} className='h-[16px] w-[16px] ml-1'/> : null}</p></td>
                    <td><p onClick={()=>onSortPress('invoiceNumber')} className='cursor-pointer flex items-center hover:text-black'>Invoice #{sort === 'invoiceNumber' || sort === '-invoiceNumber'? sort.charAt(0)==='-' ? <img src={SortIcon} className='rotate-[180deg] h-[16px] w-[16px] ml-1'/> : <img src={SortIcon} className='h-[16px] w-[16px] ml-1'/> : null}</p></td>
                    <td><p onClick={()=>onSortPress('type')} className='cursor-pointer flex items-center hover:text-black'>Type{sort === 'type' || sort === '-type'? sort.charAt(0)==='-' ? <img src={SortIcon} className='rotate-[180deg] h-[16px] w-[16px] ml-1'/> : <img src={SortIcon} className='h-[16px] w-[16px] ml-1'/> : null}</p></td>
                    <td><p onClick={()=>onSortPress('rate')} className='cursor-pointer flex items-center hover:text-black'>Rate{sort === 'rate' || sort === '-rate'? sort.charAt(0)==='-' ? <img src={SortIcon} className='rotate-[180deg] h-[16px] w-[16px] ml-1'/> : <img src={SortIcon} className='h-[16px] w-[16px] ml-1'/> : null}</p></td>
                    <td><p onClick={()=>onSortPress('totalWeight')} className='cursor-pointer flex items-center hover:text-black'>Net/Total Weight{sort === 'totalWeight' || sort === '-totalWeight'? sort.charAt(0)==='-' ? <img src={SortIcon} className='rotate-[180deg] h-[16px] w-[16px] ml-1'/> : <img src={SortIcon} className='h-[16px] w-[16px] ml-1'/> : null}</p></td>
                    <td><p onClick={()=>onSortPress('remainingWeight')} className='cursor-pointer flex items-center hover:text-black'>Remaining Weight{sort === 'remainingWeight' || sort === '-remainingWeight'? sort.charAt(0)==='-' ? <img src={SortIcon} className='rotate-[180deg] h-[16px] w-[16px] ml-1'/> : <img src={SortIcon} className='h-[16px] w-[16px] ml-1'/> : null}</p></td>
                    <td><p onClick={()=>onSortPress('receivedDate')} className='cursor-pointer flex items-center hover:text-black'>Received On{sort === 'receivedDate' || sort === '-receivedDate'? sort.charAt(0)==='-' ? <img src={SortIcon} className='rotate-[180deg] h-[16px] w-[16px] ml-1'/> : <img src={SortIcon} className='h-[16px] w-[16px] ml-1'/> : null}</p></td>
                    {/* <td><p onClick={()=>onSortPress('status')} className='cursor-pointer flex items-center hover:text-black'>Status{sort === 'status' || sort === '-status'? sort.charAt(0)==='-' ? <img src={SortIcon} className='rotate-[180deg] h-[16px] w-[16px] ml-1'/> : <img src={SortIcon} className='h-[16px] w-[16px] ml-1'/> : null}</p></td>
                    */}
                    </tr>
                </thead>
                <tbody>
                    {
                        gardens.map((item,index)=>
                        {
                            return <Link to={`/raw-tea/${item.id}`} key={index}> 
                                <tr> 
                                <td className='capitalize'>
                                    <div className='flex'>
                                    <div>
                                        <p className='text-sm font-medium my-0'>{item.garden.name}</p>
                                    </div>
                                    </div>
                                </td>
                                <td className='capitalize'>
                                    <div className='flex'>
                                    <div>
                                        <p className='text-sm font-medium my-0'>{item.gradeId ? item.grade.name  : 'N/A'}</p>
                                    </div>
                                    </div>
                                </td>
                                <td className='capitalize'>
                                <div>
                                        <p className='text-sm font-medium my-0'>{item.invoiceNumber}</p>
                                    </div>
                                </td>

                                <td className='capitalize'>
                                <div>
                                        <p className='text-sm font-medium my-0 capitalize'>{item.type} Tea</p>
                                    </div>
                                </td>
                                <td className='capitalize'>
                                <div>
                                        <p className='text-sm font-medium my-0'>{item.rate ? `Rs.${item.rate}` : 'N/A'}</p>
                                    </div>
                                    </td>
                                <td className='capitalize'>
                                <div>
                                        <p className='text-sm font-medium my-0'>{item.totalWeight < 1000 ? `${item.totalWeight.toFixed(2)} Kg` : `${(item.totalWeight/1000).toFixed(2)} Ton` }</p>
                                        <p className='text-[13px] text-gray-400 my-0 lowercase'>{item.bags} Bags</p>
                                    </div>
                                </td>
                                <td className='capitalize'>
                                <div>
                                        <p className='text-sm font-medium my-0'>{item.remainingWeight < 1000 ? `${item.remainingWeight.toFixed(2)} Kg` : `${(item.remainingWeight/1000).toFixed(2)} Ton` }</p>
                                        <p className='text-[13px] text-gray-400 my-0 lowercase'>{item.remainingBags} Bags</p>
                                    </div>
                                </td>
                                <td className='capitalize'>
                                <div>
                                        <p className='text-sm font-medium my-0'>{item.receivedDate ? getDateFormat(item.receivedDate) : getDateFormat(item.createdAt)}</p>
                                        <p className='text-[13px] text-gray-400 my-0 lowercase'>{item.receivedDate ? getTimeFormat(item.receivedDate) : getTimeFormat(item.createdAt)}</p>
                                    </div>
                                </td>
                                {/* <td className='capitalize'>
                                <div>
                                        <p className={`text-[13px] font-medium px-3 inline-block py-1 rounded-md ${parseInt(item.status) ===  1 ? 'bg-[#39C7A5] bg-opacity-50 text-green-700 ' : 'text-red-700 bg-red-200 bg-opacity-10'}}`}>{parseInt(item.status) ===  1 ? 'Active' : 'Inactive'}</p>
                                    </div>
                                </td> */}
                            </tr>
                            </Link>
                        })
                    }
                </tbody>
            </table>
        </div>
        { showCreate.status ? <ManageTea onClose={setShowCreate} onSubmit={onSubmit} edit={showCreate.edit}/> : null}
        { showFilters ? <FilterTea filters={filters} onSubmit={onFilterSubmit} onClose={setShowFilters} clearFilter={clearFilter}/> : null}
    </>
  )
}

